import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { getFavoriteListingIds } from '../../ducks/favorites.duck';

const queryFavoriteListingsPayloadCreator = (config, thunkAPI) => {
  const { dispatch, getState, extra: sdk, rejectWithValue } = thunkAPI;
  const { currentUser } = getState().user;
  const listingIds = getFavoriteListingIds(currentUser);

  if (listingIds.length === 0) {
    return Promise.resolve([]);
  }

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  return sdk.listings
    .query({
      ids: listingIds,
      include: ['images', 'author'],
      'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      return response.data.data.map(listing => listing.id);
    })
    .catch(e => {
      return rejectWithValue(storableError(e));
    });
};

export const queryFavoriteListingsThunk = createAsyncThunk(
  'app/FavoriteListingsPage/queryFavoriteListings',
  queryFavoriteListingsPayloadCreator
);

const initialState = {
  favoriteListingIds: [],
  queryListingsInProgress: false,
  queryListingsError: null,
};

const favoriteListingsPageSlice = createSlice({
  name: 'FavoriteListingsPage',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(queryFavoriteListingsThunk.pending, state => {
        state.queryListingsInProgress = true;
        state.queryListingsError = null;
      })
      .addCase(queryFavoriteListingsThunk.fulfilled, (state, action) => {
        state.favoriteListingIds = action.payload;
        state.queryListingsInProgress = false;
      })
      .addCase(queryFavoriteListingsThunk.rejected, (state, action) => {
        state.queryListingsInProgress = false;
        state.queryListingsError = action.payload;
      });
  },
});

export default favoriteListingsPageSlice.reducer;

export const loadData = (params, search, config) => dispatch => {
  return dispatch(queryFavoriteListingsThunk(config));
};
